module.exports = __webpack_public_path__ + "img/hoteles.91004565.jpeg";